import React, { useEffect, useState } from "react";
import Header from "../header/header";
import Menu from "../header/menu";
import "../header/header.css";
import Footer from "../footer/footer";
import PageRouter from "../router/router";
import Color from "../backend/color";
import Cookies from "js-cookie";
import { UserStore } from "../store/store";
import { AccessStore } from "../store/accessStore";
import { ErrorStore } from "../store/errorStore";
import { PlanStore } from "../store/planStore";
import { DarkModeStore } from "../store/darkModeStore";
import { LanStore } from "../store/lanStore";
import Head from "../head/head";
import {
  getApiSetup,
  getImagesById,
  renewToken,
  setTokenSession,
  saveDetail,
  getAWSUrl,
} from "../api/core";
import Loader from "../loader/loader";
import NotFound from "../notfound/notfound";
import Fonts from "../backend/fonts";
import Global from "../../global.js";
import CookieConsent from "react-cookie-consent";
import InPlayer from "../backend/inplayer";
import User from "../../user";
import { clearOut } from "../login/logout";
import { useHistory } from "react-router-dom";
import { getSetting, intializeSetting, isEmpty } from "../javascript/function";
import "../../i18next/i18";
import i18next from "i18next";
import AppIdInput from "./appIdInput.js";

const Home = (props) => {
  const [appId, setAppId] = useState("");
  const obj = {
    images: {
      application: "",
      createdBy: "",
      date: "",
      imageName: "",
      imagekey: localStorage.getItem("prev_logo")
        ? localStorage.getItem("prev_logo")
        : "",
    },
  };
  const footObj = {
    sectionHeader1: "",
    sectionHeader2: "",
    sectionHeader3: "",
    facebookLink: "",
    youtubeLink: "",
    instagramLink: "",
    twitterLink: "",
    items: [],
    footDescription: "",
  };
  const [col, setCol] = useState([]);
  const [fon, setFon] = useState([]);
  const [brand, setBrand] = useState([]);
  const [nav, setNav] = useState([]);
  const [expire, setExpire] = useState(false);
  const [appTitle, setAppTitle] = useState("");
  const [error, SetError] = useState(false);
  const [showAppIdInput, setShowAppIdInput] = useState(false);
  const [loginFlag, SetLoginFlag] = useState(false);
  const [mainLogo, SetMainLogo] = useState(obj);
  const [footLogo, SetFootLogo] = useState(obj);
  const [mainDarkLogo, SetMainDarkLogo] = useState(obj);
  const [footDarkLogo, SetFootDarkLogo] = useState(obj);
  const [footerInfo, SetFooterInfo] = useState(footObj);
  const [loading, isLoading] = useState(true);
  const [aloading, isAloading] = useState(false);
  const [loadingState, setLoadingState] = useState("Default");
  const theme = DarkModeStore.useState((s) => s.themeMode);
  const plan = PlanStore.useState((s) => s.plan);
  let history = useHistory();
  useEffect(() => {
    const lanCodes = [
      "ar",
      "arc",
      "dv",
      "fa",
      "ha",
      "he",
      "khw",
      "ks",
      "ku",
      "ps",
      "ur",
      "yi",
    ];
    const accessFunc = async () => {
      isAloading(true);
      /* eslint-disable no-unused-vars */
      const access = await InPlayer.Asset.checkAccessForAsset(
        Global.OFFERS[0].planid
      )
        .then((data) => {
          PlanStore.update((s) => {
            s.plan = data;
          });

          isAloading(false);
        })
        .catch((error) => {
          isAloading(false);
        });
    };
    if (!localStorage.getItem("favourites")) {
      localStorage.setItem("favourites", JSON.stringify([]));
    }
    if (!localStorage.getItem("video_list")) {
      localStorage.setItem("video_list", JSON.stringify([]));
    }

    if (!localStorage.getItem("application")) {
      localStorage.setItem("application", props.match.params.AppId);
    } else {
      let local_app = localStorage.getItem("application");
      if (local_app !== props.match.params.AppId && props.match.params.AppId) {
        clearOut();
        localStorage.setItem("application", props.match.params.AppId);
      } else {
        clearOut();
      }
    }
    const AppImages = async (id, darkMode) => {
      /* eslint-disable no-unused-vars */
      const result = await getImagesById(id.mainLogo).then(
        (result) => {
          SetMainLogo(result.data);
          Global.Header = result.data.images.imagekey;
          localStorage.setItem("prev_logo", result.data.images.imagekey);
        },
        (error) => {}
      );
      const results = await getImagesById(id.footerLogo).then(
        (result) => {
          SetFootLogo(result.data);
          localStorage.setItem("foot_logo", result.data.images.imagekey);
        },
        (error) => {}
      );
      const res = await getImagesById(id.iconLogo).then(
        (result) => {
          Global.WEBICON = result.data.images.imagekey;
          localStorage.setItem("icon_logo", result.data.images.imagekey);
        },
        (error) => {}
      );
      if (darkMode) {
        const dresult = await getImagesById(id.mainDarkLogo).then(
          (result) => {
            SetMainDarkLogo(result.data);
            Global.DarkHeader = result.data.images.imagekey;
            localStorage.setItem("prev_logo", result.data.images.imagekey);
          },
          (error) => {}
        );
        const dresults = await getImagesById(id.footerDarkLogo).then(
          (result) => {
            SetFootDarkLogo(result.data);
            localStorage.setItem("foot_logo", result.data.images.imagekey);
          },
          (error) => {}
        );
      }

      /* eslint-disable no-unused-vars */
    };
    const AppDetail = async (id) => {
      /* eslint-disable no-unused-vars */
      setAppId("");
      const result = await getApiSetup(id).then(
        (result) => {
          if (result.data.length === 0) {
            SetError(true);
            isLoading(false);
            isAloading(false);
          } else {
            setExpire(result.data[0].expireStatus);
            setCol(result.data[0].color[0]);
            setFon(result.data[0].font[0]);
            setBrand(result.data[0].branding[0]);
            AppImages(
              result.data[0].branding[0],
              result.data[0].setting[0].darkMode
            );
            setNav(result.data[0].menu);
            setAppTitle(result.data[0].setting[0].title);
            saveDetail("color", result.data[0].color[0]);
            saveDetail(
              "font",
              result.data[0].font[0] == null
                ? "Default"
                : result.data[0].font[0]
            );
            if (result.data[0].footer[0] != null) {
              SetFooterInfo(result.data[0].footer[0]);
            }
            if (
              result.data[0].font.length !== 0 &&
              result.data[0].websetting.length !== 0 &&
              result.data[0].branding.length !== 0 &&
              result.data[0].color.length !== 0 &&
              result.data[0].menu.length !== 0 &&
              result.data[0].videocloud.length !== 0
            ) {
              Global.TYPE = result.data[0].appType;
              Global.TITLE = result.data[0].setting[0].title;
              Global.NAME = result.data[0].appName;
              Global.SITEDESCRIPTION =
                result.data[0].setting[0].SITEDESCRIPTION;
              Global.APP = result.data[0].setting[0].application;
              Global.RPB = result.data[0].setting[0].resumePlayback;
              Global.SOS = result.data[0].setting[0].socialSharing;
              Global.BACKGROUND = result.data[0].setting[0].domainName;
              Global.LANGUAGE = result.data[0].languages;
              Global.DEFAULT_LAN =
                result.data[0].languages && result.data[0].languages.length > 0
                  ? result.data[0].languages[0].languageid
                  : "en";
              LanStore.update((s) => {
                s.language =
                  result.data[0].languages &&
                  result.data[0].languages.length > 0
                    ? result.data[0].languages[0]
                    : null;
              });

              i18next.changeLanguage(
                result.data[0].languages && result.data[0].languages.length > 0
                  ? result.data[0].languages[0].languageid
                  : "en"
              );
              Global.RTL =
                result.data[0].languages && result.data[0].languages.length > 0
                  ? lanCodes.indexOf(result.data[0].languages[0].languageid) !==
                    -1
                    ? true
                    : false
                  : false;
              Global.DARK_MODE = result.data[0].setting[0].darkMode;
              Global.BEW = result.data[0].setting[0].bingeWatching;
              Global.SUBSCRIPTION = result.data[0].setting[0].allowSubscription;
              Global.LOGIN = result.data[0].setting[0].allowLogin;
              Global.ICON = result.data[0].setting[0].premiumIconVisibility;
              Global.ICONNAME = result.data[0].setting[0].premiumIcon;
              Global.ML = result.data[0].setting[0].multiLanguage;
              Global.WATCHHISTORY = result.data[0].setting[0].watchHistory;
              Global.FAVOURITES = result.data[0].setting[0].favourites;
              Global.Menu = parseInt(
                result.data[0].websetting[0].numberofMenuItem
              );
              Global.FLOAT = result.data[0].websetting[0].float;
              Global.Cookie = result.data[0].websetting[0].cookiePolicy;
              Global.SHADING = result.data[0].websetting[0].shading;
              Global.THBTD = result.data[0].websetting[0].thumbnailDescription;
              Global.Gdpr = result.data[0].setting[0].gdpr;
              Global.BORDER = result.data[0].websetting[0].imageBorder;
              Global.CLIENTID =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].uuid
                  : "";
              Global.VCMS = result.data[0].videocloud[0].cloudName;
              Global.LIVE = result.data[0].videocloud[0].liveCloudName
                ? result.data[0].videocloud[0].liveCloudName
                : "JWPLAYER";

              if (result.data[0].videocloud[0].cloudName === "YouTube") {
                //API KEY
                Global.JWAPIKEYV1 = result.data[0].videocloud[0].cloudKey;
                //CHANNEL ID
                Global.JWAPIKEYV2 = result.data[0].videocloud[0].cloudSecret;
                //RECOMMENDED PLAYLIST

                Global.JWAPIKEYV3 = result.data[0].videocloud[0].cloudKeyV2;
              } else {
                Global.JWAPIKEYV1 = result.data[0].videocloud[0].cloudSecret;
                Global.JWAPIKEYV2 = result.data[0].videocloud[0].cloudSecretV2;
                Global.FSP = result.data[0].videocloud[0].firstPlayer;
                Global.SDP = result.data[0].videocloud[0].secondPlayer;
                Global.DHP = result.data[0].videocloud[0].drmTVKey;
                Global.DMP = result.data[0].videocloud[0].drmKey;
                Global.DLP = result.data[0].videocloud[0].drmMobileKey;
                Global.SPL = result.data[0].videocloud[0].searchPlaylist;
                Global.WHPL = result.data[0].videocloud[0].watchPlaylist;
                Global.RVPL = result.data[0].videocloud[0].recommendedPlaylist;
              }

              Global.DARK = result.data[0].color[0].dark;
              Global.OFFERS =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].plans
                  : [];
              Global.SRM =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].SRMName
                  : "";
              Global.OTP =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].otp
                  : false;
              Global.CLM =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].customLogin
                  : false;
              Global.CLMURL =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].customLoginUrl
                  : "";

              Global.CSM =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].customPayment
                  : false;
              Global.CSMURL =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].checkoutUrl
                  : "";
              Global.UUID =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].uuid
                  : "";
              Global.OTPKey =
                result.data[0].subscription.length !== 0
                  ? result.data[0].subscription[0].otpKey
                  : "";
              Global.Loader = result.data[0].websetting[0].loadingSpinner;
              Global.TEXTSHADOW = result.data[0].color[0].TEXTSHADOW;

              /*  let obj = {
              APP: result.data[0].setting[0].application,
            }
            UserStore.update((s) => {
              s.global = obj;
            });
 */

              let themeJSon = getSetting();

              DarkModeStore.update((s) => {
                s.themeMode = !isEmpty(themeJSon)
                  ? themeJSon.DARK_MODE
                  : Global.DARK;
              });
              if (!Global.customLogin) {
                if (
                  InPlayer.Account.isAuthenticated() &&
                  (Global.LOGIN || Global.SUBSCRIPTION)
                ) {
                  InPlayer.Account.getAccountInfo(InPlayer.Account.getToken())
                    .then((data) => {
                      User.NAME = data.data.full_name;
                      User.EMAIL = data.data.email;
                      User.PHONE = data.data.metadata.phoneNumber;
                      User.COUNTRY = data.data.metadata.country;
                      User.PHONE_VERIFIED =
                        data.data.metadata.phone_verifed === "true";
                      User.UUID = data.data.tenant_uuid;
                      User.FAVOURITES = data.data.metadata.favourites
                        ? JSON.parse(data.data.metadata.favourites)
                        : [];
                      User.WATCHHISTORY = data.data.metadata.watchHistory
                        ? JSON.parse(data.data.metadata.watchHistory)
                        : [];

                      User.SETTINGS = data.data.metadata.settings
                        ? JSON.parse(data.data.metadata.settings)
                        : intializeSetting();

                      localStorage.setItem(
                        "favourites",
                        data.data.metadata.favourites
                          ? data.data.metadata.favourites
                          : JSON.stringify([])
                      );
                      localStorage.setItem(
                        "settings",
                        data.data.metadata.settings
                          ? data.data.metadata.settings
                          : JSON.stringify(intializeSetting())
                      );
                      localStorage.setItem(
                        "video_list",
                        data.data.metadata.watchHistory
                          ? data.data.metadata.watchHistory
                          : JSON.stringify([])
                      );
                      UserStore.update((s) => {
                        s.user = User;
                      });
                      let themeFlag = User.SETTINGS.DARK_MODE;
                      DarkModeStore.update((s) => {
                        s.themeMode = themeFlag;
                      });
                      InPlayer.subscribe(User.UUID, {
                        onMessage: function (message) {
                          const obj = JSON.parse(message);

                          if (obj.type === "payment.card.success") {
                            AccessStore.update((s) => {
                              s.accessPlan = obj;
                            });
                          }
                          if (obj.type === "payment.card.failed") {
                            ErrorStore.update((s) => {
                              s.error = obj;
                            });
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/failed";
                            history.push(path);
                          }
                          if (obj.type === "external.payment.success") {
                            AccessStore.update((s) => {
                              s.accessPlan = obj;
                            });
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/success";
                            history.push(path);
                          }
                          if (obj.type === "external.payment.failed") {
                            ErrorStore.update((s) => {
                              s.error = obj;
                            });
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/failed";
                            history.push(path);
                          }

                          if (obj.type === "subscribe.success") {
                            AccessStore.update((s) => {
                              s.accessPlan = obj;
                            });
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/success";
                            history.push(path);
                          }
                          if (obj.type === "subscribe.failed") {
                            ErrorStore.update((s) => {
                              s.error = obj;
                            });
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/failed";
                            history.push(path);
                          }

                          if (obj.type === "access.revoked") {
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/revoked";
                            history.push(path);
                          }
                          if (obj.type === "account.logout") {
                            let path =
                              "/" + props.match.params.AppId + "/login";
                            history.push(path);
                          }
                          if (obj.type === "access.granted") {
                            AccessStore.update((s) => {
                              s.accessPlan = obj;
                            });
                            let path =
                              "/" +
                              props.match.params.AppId +
                              "/payment/status/success";
                            history.push(path);
                          }
                        },
                        onOpen: function (e) {},
                        onClose: function (e) {},
                      });

                      if (Global.SUBSCRIPTION && Global.LOGIN) {
                        accessFunc();
                      }

                      Cookies.set("sm_ott_val", User.PHONE_VERIFIED, {
                        expires: 2,
                      });
                      isLoading(false);
                    })
                    .catch((error) => {
                      SetLoginFlag(true);
                      if (
                        error.response.status === 401 ||
                        error.response.status === 403
                      ) {
                        const { refreshToken } = JSON.parse(
                          localStorage.getItem("inplayer_token")
                        );
                        if (refreshToken) {
                          InPlayer.Account.signIn({
                            clientId: Global.CLIENTID,
                            grant_type: "refresh_token",
                            refreshToken: refreshToken,
                          })
                            .then((data) => {
                              User.NAME = data.data.account.full_name;
                              User.EMAIL = data.data.account.email;
                              User.PHONE =
                                data.data.account.metadata.phoneNumber;
                              User.PHONE_VERIFIED =
                                data.data.account.metadata.phone_verifed;
                              User.WATCHHISTORY = data.data.account.metadata
                                .watchHistory
                                ? JSON.parse(
                                    data.data.account.metadata.watchHistory
                                  )
                                : [];
                              User.FAVOURITES = data.data.account.metadata
                                .favourites
                                ? JSON.parse(
                                    data.data.account.metadata.favourites
                                  )
                                : [];
                              User.SETTINGS = data.data.metadata.settings
                                ? JSON.parse(data.data.metadata.settings)
                                : intializeSetting();
                              User.COUNTRY = data.data.account.metadata.country;

                              UserStore.update((s) => {
                                s.user = User;
                              });
                              let themeFlag = User.SETTINGS.DARK_MODE;
                              DarkModeStore.update((s) => {
                                s.themeMode = User.themeFlag;
                              });
                              SetLoginFlag(false);
                            })
                            .catch((error) => {
                              InPlayer.Account.removeToken();
                              let path =
                                "/" + props.match.params.AppId + "/login";
                              window.location.href = path;
                              SetLoginFlag(false);
                            });
                        } else {
                          SetLoginFlag(false);
                          InPlayer.Account.removeToken();
                        }
                      }

                      isLoading(false);
                    });
                } else {
                  isLoading(false);
                }
              } else {
                isLoading(false);
              }

              setLoadingState(result.data[0].websetting[0].loadingSpinner);

              SetError(false);
            } else {
              SetError(true);
            }
          }
        },
        (error) => {
          if (error.response == null) {
            SetError(true);
          } else {
            if (error.response.data === "Invalid Token") {
              AppToken(id);
              window.location.reload(false);
            } else {
              SetError(true);
            }
          }
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const AppToken = async (id) => {
      /* eslint-disable no-unused-vars */
      setTokenSession("");
      const result = await renewToken(id).then(
        (result) => {},
        (error) => {}
      );
    };

    if (props.match?.params.AppId) {
      AppDetail(props.match.params.AppId);
    } else {
      setShowAppIdInput(true);
    }
  }, [props.match.params.AppId, history, appId]);
  if (showAppIdInput) {
    return (
      <AppIdInput setAppId={setAppId} setShowAppIdInput={setShowAppIdInput} />
    );
  }
  if ((loading || loginFlag || aloading) && !error) {
    return <Loader load={loadingState}></Loader>;
  } else {
    if (error && !aloading) {
      return (
        <NotFound
          code={"500 ERROR"}
          message={"Unable to Fetch the Application Data"}
          {...props}
        ></NotFound>
      );
    } else if (error && aloading) {
      return (
        <NotFound
          code={"Invalid Application ID"}
          message={"Application ID seems to be invalid"}
          {...props}
        ></NotFound>
      );
    } else {
      if (!expire) {
        return (
          <div className="App">
            <Head
              title={Global.TITLE}
              quote={""}
              description={Global.SITEDESCRIPTION}
              rtl={Global.RTL}
              image={
                mainLogo.images ? getAWSUrl() + mainLogo.images.imagekey : ""
              }
              icon={Global.WEBICON ? getAWSUrl() + Global.WEBICON : ""}
            ></Head>

            <Color data={col} title={appTitle} theme={theme} {...props}></Color>
            <Fonts font={fon}></Fonts>
            {props.match.params.page !== "watch" &&
            props.match.params.page !== "livePage" &&
            props.match.params.AppId !== null &&
            props.match.params.AppId !== undefined &&
            props.match.params.pageType !== "welcome" &&
            props.match.params.pageType !== "login" &&
            props.match.params.pageType !== "register" &&
            props.match.params.pageType !== "premium" &&
            props.match.params.page !== "premium" &&
            props.match.params.pageType !== "payment" &&
            props.match.params.pageType !== "verify" &&
            props.match.params.pageType !== "sendotp" ? (
              // <Header
              //   data={nav}
              //   branding={mainLogo.images.imagekey}
              //   {...props}
              // ></Header>

              Global.TYPE === "News" ? (
                <Menu
                  data={nav}
                  branding={
                    theme === Global.DARK
                      ? mainLogo.images.imagekey
                      : mainDarkLogo.images.imagekey
                  }
                  theme={theme}
                  {...props}
                ></Menu>
              ) : (
                <Header
                  data={nav}
                  branding={
                    theme === Global.DARK
                      ? mainLogo.images.imagekey
                      : mainDarkLogo.images.imagekey
                  }
                  theme={theme}
                  {...props}
                ></Header>
              )
            ) : (
              ""
            )}
            <div style={{ minHeight: "450px" }}>
              <PageRouter menu={nav} {...props}></PageRouter>
            </div>

            {Global.Cookie ? (
              <CookieConsent
                location="bottom"
                buttonText="I Understand"
                enableDeclineButton
                cookieName="cookiePolicy"
                style={{
                  background: "var(--iq-secondy-body)",
                  color: "var(--iq-body-text)",
                }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                expires={365}
              >
                We and selected third parties use cookies or similar
                technologies for technical purposes and, with your consent, for
                other purposes as specified in the{" "}
                <a href="/cookiepolicy" style={{ color: "var(--iq-primary)" }}>
                  Cookie policy
                </a>
                . You can consent to the use of such technologies by using the
                “Accept” button. By closing this notice, you continue without
                accepting.
              </CookieConsent>
            ) : (
              ""
            )}

            {Global.Gdpr ? (
              <CookieConsent
                location="bottom"
                buttonText="I Understand"
                enableDeclineButton
                cookieName="gdprPolicy"
                style={{
                  background: "var(--iq-secondy-body)",
                  color: "var(--iq-body-text)",
                }}
                buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
                expires={365}
              >
                By continuing to the website you will be agreeing to the website{" "}
                <a href="/terms" style={{ color: "var(--iq-primary)" }}>
                  Terms and Conditions
                </a>{" "}
                and the Use of{" "}
                <a href="/cookiepolicy" style={{ color: "var(--iq-primary)" }}>
                  Cookies
                </a>{" "}
                while using the website and our services. Please also read our{" "}
                <a href="/privacypolicy" style={{ color: "var(--iq-primary)" }}>
                  {" "}
                  Privacy Policy
                </a>{" "}
                which to the extend stated, you consent to the processing of
                your personal data.
              </CookieConsent>
            ) : (
              ""
            )}
            {props.match.params.page !== "watch" &&
            props.match.params.page !== "livePage" &&
            props.match.params.AppId !== null &&
            props.match.params.AppId !== undefined &&
            props.match.params.pageType !== "login" &&
            props.match.params.pageType !== "register" &&
            props.match.params.pageType !== "payment" &&
            props.match.params.page !== "premium" &&
            props.match.params.pageType !== "premium" ? (
              <Footer
                data={
                  theme === Global.DARK
                    ? footLogo.images.imagekey
                    : footDarkLogo.images.imagekey
                }
                foot={footerInfo}
                branding={brand}
                {...props}
              ></Footer>
            ) : (
              ""
            )}
          </div>
        );
      } else {
        return (
          <NotFound
            code={"License Expired"}
            message={
              "Your Demo License is Expired. Please Contact sales team to extend the Trial"
            }
            {...props}
          ></NotFound>
        );
      }
    }
  }
};
export default Home;
